import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

interface IQuotaTooltipContentProps {
    title?: string;
    description: string;
    buttonText?: string;
    onClick?: VoidFunction;
}

export const QuotaTooltipContent = ({ title, description, buttonText, onClick }: IQuotaTooltipContentProps) => {
    return (
        <Stack>
            {title ? <Text fontVariant="listItem4">{title}</Text> : null}
            <Text fontVariant="tooltip">{description}</Text>

            {buttonText && onClick ? (
                <Text
                    as="a"
                    onClick={onClick}
                    fontVariant="tooltip"
                    color={colorsPalettes.blue[300]}
                    cursor="pointer"
                >
                    {buttonText}
                </Text>
            ) : null}
        </Stack>
    );
};
